var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="\n<div layout=\"column\" ng-if=\"selected\" ng-class=\"{current: selected, done: completed}\" class=\"step\" ng-transclude>\n</div>";
var id1="public/user-controls/wizard-step-template.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./app/components/public/user-controls/wizard-step-template.html
// module id = 678
// module chunks = 0